import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layouts/layout/layout.component';
import { LoginComponent } from './auth/login/login.component';
import { PasswordResetComponent } from './auth/password-reset/password-reset.component';
import { EmailVerifyComponent } from './auth/email-verify/email-verify.component';
import { EmailResetPasswordComponent } from './auth/email-reset-password/email-reset-password.component';
import { SignUpComponent } from './auth/signup/signup.component';
import { SignUpSuccessComponent } from './auth/signup-success/signup-success.component';
import { AuthGuard } from './services/auth.guard';
import { HeaderNewComponent } from './layouts/header-new/header-new.component';
import { NotLoggedInComponent } from './auth/not-logged-in/not-logged-in.component';
import { AutomapComponent } from './pages/automap/automap.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    loadChildren: () => import('./pages/pages.module').then((m) => m.PagesModule),
    canActivateChild: [AuthGuard],
  },
  {
    path: 'header',
    component: HeaderNewComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    data: { title: 'AutomapAI - Log in' },
  },
  {
    path: 'home',
    component: NotLoggedInComponent,
    data: { title: 'AutomapAI' },
  },
  {
    path: 'signup',
    component: SignUpComponent,
    data: { title: 'AutomapAI - Sign Up' },
  },
  {
    path: 'signup-success',
    component: SignUpSuccessComponent,
    data: { title: 'AutomapAI - Sign Up Request Submitted' },
  },
  {
    path: 'email-verify',
    component: EmailVerifyComponent,
    data: { title: 'AutomapAI - Verify Email' },
  },
  {
    path: 'email-reset-password',
    component: EmailResetPasswordComponent,
    data: { title: 'AutomapAI - Reset Password' },
  },
  {
    path: 'password-reset',
    component: PasswordResetComponent,
    data: { title: 'AutomapAI - Reset Password' },
  },
  {
    path: 'password-reset/:username/:token',
    component: PasswordResetComponent,
    data: { title: 'AutomapAI - Reset Password' },
  },
  {
    path: '**',
    component: AutomapComponent,
    data: { title: 'AutomapAI', error: true },
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: 'ignore',
      urlUpdateStrategy: 'eager',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
